'use client'

import { useCallback, useRef } from 'react'
import { Cog } from 'lucide-react'

import type { HomePageContent } from '@/lib/content/defaults/home'
import { ProcessTimeline } from '@/components/process-timeline'

interface ProcessCogProps {
  content: HomePageContent['process']
}

export function ProcessCog({ content }: ProcessCogProps) {
  const cogRef = useRef<SVGSVGElement>(null)

  const handleProgress = useCallback((p: number) => {
    if (cogRef.current) {
      cogRef.current.style.transform = `rotate(${p * 360}deg)`
    }
  }, [])

  return (
    <>
      <h2 className="font-display flex items-center justify-center gap-4 text-center text-4xl font-bold text-white sm:text-5xl">
        <Cog
          ref={cogRef}
          className="text-brand-chartreuse-vivid size-10 shrink-0 sm:size-12 lg:size-14"
          aria-hidden="true"
        />
        {content.heading}
      </h2>
      <div className="mt-14 sm:mt-16">
        <ProcessTimeline
          steps={content.steps}
          stepLabel={content.stepLabel}
          onProgress={handleProgress}
        />
      </div>
    </>
  )
}
